import { AlertIcon } from '@primer/octicons-react';
import { Box, Flash, Octicon } from '@primer/react';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../state/reducers';
import HocSinhShortInfo from '../hoc-sinh/hoc-sinh-short-info';
import ThuPhiLayout from './ThuPhiLayout';


interface IThuPhiHocSinhProps {
    selectedTabId: string
}
const ThuPhiHocSinh = (props: IThuPhiHocSinhProps) => {
    const { tabs } = useSelector((x: RootState) => x.thuPhiTab);
    const { selectedTabId } = props;
    const selectedTab = useMemo(() => {
        return tabs.find(x => x.id === selectedTabId)
    }, [tabs, selectedTabId])
    const hocSinhId = selectedTab?.hocSinh?.id ?? 0;
    return (
        <Box sx={{ width: "100%", mt: 2 }}>
            {selectedTab &&
                <>
                    {!selectedTab.hocSinh &&
                        <>
                            <HocSinhShortInfo hocSinh={selectedTab.hocSinh} selectedTab={selectedTab} />
                            <Flash sx={{ mt: 2 }} variant='warning'>
                                <Box>
                                    <Octicon icon={AlertIcon} />
                                    Chọn học sinh để bắt đầu thu phí
                                </Box>
                            </Flash>
                        </>
                    }
                    {selectedTab.hocSinh &&
                        <>
                            <HocSinhShortInfo hocSinh={selectedTab.hocSinh} selectedTab={selectedTab} />
                            <hr style={{ border: "none", height: "1px", backgroundColor: "#ccc", opacity: 0.5 }} />
                            <ThuPhiLayout ts_hocsinh_id={hocSinhId} />
                        </>
                    }

                </>
            }

        </Box >
    );
};

export default ThuPhiHocSinh;